import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconDash from '../icons/IconDash';
import IconUser from '../icons/IconUser';
import InputBase from '@mui/material/InputBase';
import IconBank from '../icons/IconBank';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import IconCashFlow from '../icons/IconCashFlow';
import IconChartTop from '../icons/IconChartTop';
import IconTrophy from '../icons/IconTrophy';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useLocation, useNavigate } from 'react-router-dom';
import IconCrm from '../icons/IconCrm';
import IconPainelOcupacao from '../icons/IconPainelOcupacao';
import IconChart from '../icons/IconChart';
import IconThermometer from '../icons/IconThermometer';
import { useUserStore } from '@/stores/user.ts';


const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `15px`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
    },
  },
}));

export default function MenuLayout() {
  const navigate = useNavigate();
  const { user } = useUserStore()
  const permissions = user?.permissions || []

  const [activeButton, setActiveButton] = React.useState<number | null>(12345);
  const [activeSubButton, setActiveSubButton] = React.useState<number | null>(null);
  const [expandedItem, setExpandedItem] = React.useState<number | null>(null);
  const [drawerWidth, setDrawerWidth] = React.useState(window.innerWidth < 1500 ? 230 : 252);
  const [fontSize, setFontSize] = React.useState(window.innerWidth < 1500 ? '13px' : '15px');

  React.useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(window.innerWidth < 1500 ? 230 : 252);
      setFontSize(window.innerWidth < 1500 ? '13px' : '15px');
    };
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const location = useLocation();

  function removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  
  React.useEffect(() => {
    listMenuItemsSchool.forEach((item) => {
      if (item.route && (location.pathname).toLowerCase().includes(removeAccents(item.route.toLowerCase()))) {
        setActiveButton(item.id);
        setActiveSubButton(null);
      }

      if (item.subItems) {
        item.subItems.forEach((subItem) => {
          if (subItem.title && (location.pathname).toLowerCase().includes(removeAccents(subItem.title.toLowerCase()))) {
            setActiveButton(item.id);
            setActiveSubButton(subItem.id);
          }
        });
      }
    });
  }, []);

  const listMenuItems = [
    {
      id: 1,
      title: 'Dashboard',
      icon: IconDash,
    },
    {
      id: 2,
      title: 'Usuários',
      icon: IconUser,
    },
  ];

  const listMenuItemsSchool = [
    {
      id: 3,
      title: 'Dashboard',
      icon: IconDash,
      name: 'dashboard',
      route: '/dashboard',
    },
    {
      id: 4,
      title: 'Contas a receber',
      icon: IconBank,
      name: 'contas_receber',
      route: '/accounts-to-receive',
    },
    {
      id: 5,
      title: 'Inadimplência',
      icon: TrendingDownIcon,
      name: 'inadimplencia',
      subItems: [
        {
          id: 6,
          title: 'Inadimplência',
          route: '/inadimplencia',
        },
        { id: 7, title: 'Visão histórica', route: '/inadimplencia-visao-historica' },
        { id: 8, title: 'Evolução de inadimplência', route: '/inadimplencia-evolucao' },
      ],
    },
    {
      id: 9,
      title: 'Termômetro',
      name: 'termometro',
      icon: IconThermometer,
      subItems: [
        {
          id: 10,
          title: 'Termômetro geral',
          route: '/termometro-geral',
        },
        {
          id: 11,
          title: 'Termômetro financeiro',
          route: '/termometro-financeiro',
        },
        {
          id: 12,
          title: 'Termômetro pedagógico',
          route: '/termometro-pedagogico',

        },
        {
          id: 13,
          title: 'Termômetro de frequência',
          route: '/termometro-frequencia',
        },
      ],
    },
    {
      id: 14,
      title: 'Fluxo de caixa',
      name: 'fluxo_caixa',
      icon: IconCashFlow,
      route: '/fluxo-caixa',
    },
    {
      id: 15,
      title: 'Índice de valor',
      name: 'indice_valor',
      icon: IconChartTop,
      route: '/indice-valor',
    },
    {
      id: 16,
      title: 'Raio X',
      name: 'raixo_x',
      icon: IconTrophy,
      subItems: [
        {
          id: 17,
          title: 'Alunos',
          route: '/raiox',
        },
        { id: 18, title: 'Professores', route: '/raiox-professores'},
        // { id: 19, title: 'Instituições', route: '/raiox-instituicoes' },
        { id: 20, title: 'Turmas', route: '/raiox-turmas' },

      ],
    },
    {
      id: 21,
      title: 'CRM',
      name: 'crm',
      icon: IconCrm,
      subItems: [
        {
          id: 22,
          title: 'CRM Matrícula',
          route: '/crm/matricula',
        },
        { id: 23, title: 'CRM Rematrícula', route: '/crm/rematricula' },
        { id: 24, title: 'CRM Inadimplência', route: '/crm/inadimplencia' },
        { id: 25, title: 'Dashboards', route: '/crm/dashboard' },
      ],
    },
    {
      id: 26,
      title: 'Painel de ocupação',
      name: 'painel_ocupacao',
      icon: IconPainelOcupacao,
      route: '/occupancy-panel',
    },
    {
      id: 27,
      title: 'Score Pedagógico',
      icon: IconChart,
      route: '/score-pedagogico',
    },
  ];

  const handleButtonClick = (id: number) => {
    if (expandedItem === id) {
      setExpandedItem(null);
    } else {
      setExpandedItem(id);
    }
    setActiveButton(id);
  };

  const handleSubButtonClick = (item) => {
    if (item.route) {
      navigate(item.route);
    }
    setActiveSubButton(item.id);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            height: 'calc(100% - 72px)',
            marginTop: '71px',
            background: '#fff',
            borderRight: '1px solid rgba(176, 176, 176, 1)',
            padding: '20px',
          },
        }}
        variant="persistent"
        anchor="left"
        open={true}
      >
        {/*<Typography fontWeight={500} fontSize={'18px'} color={'rgba(94, 94, 94, 1)'}>*/}
        {/*  EduQuanto*/}
        {/*</Typography>*/}
        {/*<List>*/}
        {/*  {listMenuItems.map((item) => {*/}
        {/*    const Icon = item.icon;*/}
        {/*    return (*/}
        {/*      <ListItem key={item.id} disablePadding>*/}
        {/*        <ListItemButton*/}
        {/*          sx={{*/}
        {/*            padding: '0 8px',*/}
        {/*            bgcolor: activeButton === item.id ? 'rgba(224, 74, 76, 1)' : 'transparent',*/}
        {/*            borderRadius: '24px',*/}
        {/*            '&:hover': {*/}
        {/*              backgroundColor: 'rgba(224, 74, 76, 1)',*/}
        {/*            },*/}
        {/*          }}*/}
        {/*          onClick={() => {*/}
        {/*            // @ts-ignore*/}
        {/*            if (item.route) {*/}
        {/*              // @ts-ignore*/}
        {/*              navigate(item.route)*/}
        {/*            }*/}

        {/*            handleButtonClick(item.id);*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          <ListItemIcon sx={{ minWidth: 0, marginRight: '10px' }}>*/}
        {/*            <Icon sx={{ color: activeButton === item.id ? '#fff' : 'rgba(0, 0, 0, 1)' }} />*/}
        {/*          </ListItemIcon>*/}
        {/*          <ListItemText*/}
        {/*            primary={item.title}*/}
        {/*            sx={{ '.MuiTypography-root': { color: activeButton === item.id ? '#fff' : '#000' } }}*/}
        {/*          />*/}
        {/*        </ListItemButton>*/}
        {/*      </ListItem>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</List>*/}
        {/*<Typography color={'rgba(68, 68, 68, 1)'} fontWeight={400} fontSize={'12px'} m={'8px 0'} textAlign={'center'}>*/}
        {/*  Selecione uma escola cadastrada para ter acesso aos dados dela.*/}
        {/*</Typography>*/}
        {/*<Search sx={{ border: '1px solid rgba(154, 154, 154, 1)', borderRadius: '24px', color: '#000' }}>*/}
        {/*  <SearchIconWrapper>*/}
        {/*    <SearchIcon style={{ color: 'rgba(0, 0, 0, 1)' }} />*/}
        {/*  </SearchIconWrapper>*/}
        {/*  <StyledInputBase sx={{ fontSize: '12px' }} placeholder="Pesquisar escola…" />*/}
        {/*</Search>*/}
        {/*<Typography mt={'0px'} fontWeight={500} fontSize={'18px'} color={'rgba(94, 94, 94, 1)'}>*/}
        {/*  Escola*/}
        {/*</Typography>*/}
        <List>
          {listMenuItemsSchool
              .filter(
                (item) =>
                  permissions.length === 0 ||
                  !item.name ||
                  permissions.some((perm) => perm.includes(item.name))
              )            
              .map((item) => {
              const Icon = item.icon;
              const isExpanded = expandedItem === item.id;

              return (
                <>
                  <ListItem
                    key={`${item.id}-${item.route}`}
                    disablePadding
                    sx={{
                      '&:hover': {
                        color: '#FFF',
                        span: {
                          color: '#FFF',
                        },
                        backgroundColor: 'rgba(224, 74, 76, 1)',
                        svg: {
                          color: '#FFF',
                        },
                        borderRadius: '24px',
                      },
                    }}
                  >
                    <ListItemButton
                      sx={{
                        padding: '0 8px',
                        bgcolor: activeButton === item.id ? 'rgba(224, 74, 76, 1)' : 'transparent',
                        borderRadius: '24px',
                      }}
                      onClick={() => {
                        if (item.route) {
                          navigate(item.route);
                        }

                        handleButtonClick(item.id);
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 0, marginRight: '10px' }}>
                        <Icon
                          sx={{
                            color: activeButton === item.id ? '#FFF' : 'rgba(0, 0, 0, 1)',
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.title}
                        sx={{
                          '.MuiTypography-root': {
                            color: activeButton === item.id ? '#fff' : '#000',
                            fontWeight: 600,
                            fontSize: fontSize
                          },
                        }}
                      />
                      {item.subItems &&
                        (isExpanded ? (
                          <KeyboardArrowUpIcon sx={{ color: activeButton === item.id ? '#fff' : 'rgba(0, 0, 0, 1)' }} />
                        ) : (
                          <KeyboardArrowDownIcon
                            sx={{ color: activeButton === item.id ? '#fff' : 'rgba(0, 0, 0, 1)' }}
                          />
                        ))}
                    </ListItemButton>
                  </ListItem>

                  <List>
                    {isExpanded &&
                      item.subItems &&
                      item.subItems.map((subItem) => (
                        <ListItem key={`${subItem.id}-${subItem.route}`} disablePadding>
                          <ListItemButton
                            sx={{
                              padding: '0 8px',
                              bgcolor: activeSubButton === subItem.id ? 'rgba(252, 228, 212, 1)' : 'transparent',
                              borderRadius: '24px',
                              marginBottom: '5px',
                              '&:hover': {
                                backgroundColor: 'rgba(252, 228, 212, 1)',
                                // color: '#000', // Ensure text color is black on hover
                              },
                            }}
                            onClick={() => {
                              handleSubButtonClick(subItem);
                            }}
                          >
                            <div
                              style={{
                                width: '7px',
                                height: '7px',
                                margin: '0 10px',
                                background: '#000',
                                borderRadius: '50%',
                              }}
                            ></div>
                            <ListItemText
                              primary={subItem.title}
                              sx={{ '.MuiTypography-root': { color: '#000', fontWeight: 600,  fontSize: fontSize } }}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                  </List>
                </>
              );
            })}
        </List>
      </Drawer>
    </Box>
  );
}
